import { faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

interface Props {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

export default function SharedSurveyVoiceInstruction({
  className,
  iconClassName,
  textClassName,
}: Props) {
  const t = useTranslations('Survey.voiceInstruction');

  return (
    <div
      className={cn(
        'flex items-center gap-1 font-sans text-xs text-nowrap text-gray-400',
        className
      )}
      aria-label={t('label')}
      data-test='voice-instruction'
    >
      {/* oxlint-disable react/no-unstable-nested-components */}
      {t.rich('instruction', {
        emphasis: (chunks) => (
          <span
            className={cn(
              'font-sans text-xs font-semibold text-gray-400',
              textClassName
            )}
            data-test='voice-instruction-command'
            aria-label={t('commandAriaLabel')}
          >
            {chunks}
          </span>
        ),
        icon: () => (
          <FontAwesomeIcon
            icon={faBullhorn}
            className={cn('size-4 text-gray-400', iconClassName)}
            data-test='voice-instruction-icon'
            aria-label={t('commandIconAriaLabel')}
          />
        ),
      })}
      {/* oxlint-enable react/no-unstable-nested-components */}
    </div>
  );
}
